<div #modalFiltres class="modal fade" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header bg-light">
                <h5 class="modal-title">Filtres</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">                   
                <div class="form-group mb-2">
                    <label for="filterCal">Calendrier</label>
                    <select id="filterCal" class="form-control" [(ngModel)]="filter.cal">
                        <option value="">Tous</option>
                        @if (calResource.hasValue()) {
                            @for (cal of calResource.value(); track cal.id) {
                                <option value="{{ cal.id }}"  [style.background-color]="cal.color_back"  [style.color]="cal.color_front">{{ cal.summary }}</option>
                            }
                        }
                    </select>                        
                </div>           
                <div class="form-group mb-3">
                    <label for="filterYear">Date</label>
                    <select id="filterYear" class="form-control" [(ngModel)]="filter.year">
                        <option value="-2">A venir</option>
                        @for (n of annees; track n) {
                            <option value="{{ Config.LAST_YEAR - n + 1 }}">{{ Config.LAST_YEAR - n + 1 }}</option>                
                        }
                        <option value="-1">Tout</option>
                    </select>
                </div>                           
                <div class="form-check form-switch d-flex align-items-center text-start">
                    <input class="form-check-input" type="checkbox" role="switch" id="filterDisplayDeleted" [(ngModel)]="filter.displayDeleted">
                    <label class="form-check-label ms-2" for="filterDisplayDeleted"> Afficher les dates supprimées</label>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Annuler</button>
                <button type="button" class="btn btn-success" data-bs-dismiss="modal" (click)="accept()">Valider</button>
                </div>
        </div>
    </div>
</div>